// Socket.IO module
import auth from "@/services/auth";
import router from "@/router";
import store from "@/store";
import io from "socket.io-client";

const connection = process.env.VUE_APP_BASE_API;
const dev = process.env.VUE_APP_MODE !== "PROD";
let socket = null;
/**
 * Socket se utiliza para actualización de datos de la aplicación en tiempo real
 * Se abre la conexión cuando el usuario está autenticado
 * La conexión se abre manualmente cuando el usuario inicia sesión (UserLogin.vue) y se cierra cuando el usuario cierra sesión (auth.js -> cerrarSesion())
 * La conexión se abre / cierra automáticamente desde App.js cuando la sesión está iniciada y el usuario recarga / cierra la aplicación
 * La idea de gestionar por App js es mantener la conexión disponible aun cuando el usuario recargue la página (ya que al hacer esto se perdería porque se reinicia la aplicación)
 *  */

function validateSocket() {
  if (auth.isAuthenticated && socket) return true;
  else if (!auth.isAuthenticated && socket) {
    if (socket) socket.disconnect();
    socket = null;
    return false;
  } else if (auth.isAuthenticated() && !socket) {
    socketConnect();
    if (socket) return true;
    else return false;
  } else return false;
}
function socketConnect() {
  if (!auth.isAuthenticated()) return;
  if (socket) return;
  socket = io(connection);
  updateUserBitsEvent();
  updateTicketParamsEvent();
  if (dev) console.log("Conexión Establecida");
}

function socketDisconnect() {
  if (socket) {
    socket.disconnect();
    socket = null;
    if (dev) console.log("Conexión Terminada");
  }
}

function updateUserBitsEvent() {
  if (!validateSocket()) return;
  let idNotificacion = auth.getUserLogged().id_usuario;
  socket.emit("joinRoom", idNotificacion.toString());

  socket.on("updateBits", async (data) => {
    if (dev) console.log("updateBits", data);
    await store.dispatch("updateBits", true);

    let visibleBit = router.currentRoute.meta.visible;
    let bitsCliente = store.state.bitsCliente;
    if (visibleBit && !bitsCliente[visibleBit]) router.push({ name: "perfil" });
  });
}

function updateTicketParamsEvent() {
  if (!validateSocket()) return;
  socket.on("updateTicketParams", async (data) => {
    if (dev) console.log("updateTicketParams", data);

    await store.dispatch("obtenerParametrosGenerales");
    if (store.state.paramGenerales.mantencion) router.push("/mantencion");
  });
}

export { socketDisconnect, socketConnect };
